import { Button2 } from '../Button'
import { buildValidationSchema, CFieldProps } from '@velocity/shared'
import { Form, Formik } from 'formik'
import { CFields } from '../form/Form'
import { useMemo } from 'react'

export type SearchFilterProps = {
  fields: CFieldProps[]
  onUpdate?: (value: any) => void
  loading?: boolean
}

export default function SearchFilter(props: SearchFilterProps) {
  const reportSchema = useMemo(
    () =>
      props.fields ?
        buildValidationSchema(props.fields)
      : { initialValues: {}, schema: null },
    [props.fields]
  )
  return (
    <Formik
      initialValues={reportSchema.initialValues}
      enableReinitialize={true}
      onSubmit={props.onUpdate ? props.onUpdate : () => {}}
      validationSchema={reportSchema.schema}
    >
      <Form className='sm:grid sm:grid-cols-3 lg:grid-cols-4 gap-4'>
        <CFields fields={props.fields} />
        {props.onUpdate && (
          <div className='flex items-end mb-0.5 no-print'>
            <Button2 title='Search' type='submit' loading={props.loading} />
          </div>
        )}
      </Form>
    </Formik>
  )
}
